<template>
  <div class="severity">
    <h3 class="severity-title">Overall Severity of Sample</h3>
    <div class="severity-labels">
      <div class="severity-label">
        <div class="severity-label-color severity-label-normal">
          <span class="severity-label-number">0</span>
        </div>
        <span class="severity-label-title">Normal</span>
      </div>
      <div class="severity-label">
        <div class="severity-label-color severity-label-reportable">
          <span class="severity-label-number">1</span>
        </div>
        <span class="severity-label-title">Reportable</span>
      </div>
      <div class="severity-label">
        <div class="severity-label-color severity-label-abnormal">
          <span class="severity-label-number">2</span>
        </div>
        <span class="severity-label-title">Abnormal</span>
      </div>
      <div class="severity-label">
        <div class="severity-label-color severity-label-critical">
          <span class="severity-label-number">3</span>
        </div>
        <span class="severity-label-title">Critical</span>
      </div>
      <div :class="`severity-indicator severity-indicator-${severityCode.toLowerCase()}`">
        <div class="severity-indicator-inner"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OilSampleDetailSeverity',
  props: {
    severityCode: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.severity {
  align-items: center;
  display: flex;
  flex-direction: column;

  &-title {
    @include fontSize(20px);

    text-align: center;
    padding-bottom: 10px;
  }

  &-labels {
    display: grid;
    grid-gap: 5px;
    grid-template-columns: repeat(4, 50px);
    justify-content: center;
    position: relative;
  }

  &-label {
    align-items: center;
    display: flex;
    flex-direction: column;

    &-title {
      font-size: 11px;
    }

    &-number {
      font-size: 25px;
    }

    &-color {
      align-items: center;
      border: 1px solid #000;
      display: flex;
      font-weight: bold;
      height: 50px;
      justify-content: center;
      width: 50px;
    }

    &-reportable {
      background: nth($severity-color-reportable, 2);
    }

    &-abnormal {
      background: nth($severity-color-abnormal, 2);
    }

    &-critical {
      background: nth($severity-color-critical, 2);
    }
  }

  &-indicator {
    border-color: #000 transparent transparent transparent;
    border-style: solid;
    border-width: 16px 9.25px 0 9.25px;
    height: 0;
    left: 15px;
    margin-top: -7.5px;
    position: absolute;
    width: 0;

    &-inner {
      border-color: #000 transparent transparent transparent;
      border-style: solid;
      border-width: 16px 9.25px 0 9.25px;
      height: 0;
      left: -9.25px;
      position: absolute;
      top: -16px;
      transform: scale(0.75);
      width: 0;
    }

    &-reportable {
      left: 70px;

      .severity-indicator-inner {
        border-top-color: nth($severity-color-reportable, 2);
      }
    }

    &-abnormal {
      left: 125px;

      .severity-indicator-inner {
        border-top-color: nth($severity-color-abnormal, 2);
      }
    }

    &-critical {
      left: 181px;

      .severity-indicator-inner {
        border-top-color: nth($severity-color-critical, 2);
      }
    }
  }
}
</style>
